import _ from "underscore";

_.noConflict = () => _;// just do nothing but fix issues when a script in the page use it, because it's a es6 version ("is not present if you use the EcmaScript 6" http://underscorejs.org/#noConflict )

let warnGlobalUnderscoreUsage = true;
// tmp fix for scripts that should import underscore instead of use global property
Object.defineProperty(window, "_", {
  get: () => {
    if(warnGlobalUnderscoreUsage){
      console.warn("Use global underscore is depreciated, use native ECMAScript APIs or 'import _ from \"underscore\";' instead.");
    }
    warnGlobalUnderscoreUsage = false;
    return _;
  }
});
